/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectCreateDto } from '../../models/core-project-create-dto';
import { CoreProjectResponseDto } from '../../models/core-project-response-dto';

export interface ProjectsControllerCreate$Params {
  tenant: string;
      body: CoreProjectCreateDto
}

export function projectsControllerCreate(http: HttpClient, rootUrl: string, params: ProjectsControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectsControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectResponseDto>;
    })
  );
}

projectsControllerCreate.PATH = '/o2-core/projects/{tenant}';
